import React from "react";
import { Link } from "@/lib/router-compat";
import { ChevronRight, Home } from "lucide-react";
import { Crumb } from "./schemaConstants";

/**
 * Visible breadcrumb trail reflecting real URL hierarchy.
 * Renders as Home > Section > Page. The final crumb (current page) is shown
 * as plain text (not a link). Matches the BreadcrumbList JSON-LD exactly.
 */
export const Breadcrumbs: React.FC<{
  crumbs: Crumb[];
  className?: string;
}> = ({ crumbs, className = "" }) => {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground">
        <li className="flex items-center gap-1.5">
          <Link
            to="/"
            className="inline-flex items-center gap-1 hover:text-accent transition-colors"
          >
            <Home className="h-3.5 w-3.5" />
            <span className="sr-only">Home</span>
          </Link>
        </li>
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50" />
              {isLast ? (
                <span
                  className="font-semibold text-primary"
                  aria-current="page"
                >
                  {c.name}
                </span>
              ) : (
                <Link
                  to={c.href}
                  className="hover:text-accent transition-colors"
                >
                  {c.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
